import React, { useReducer, useEffect, useContext, useState } from "react";
import moduleConfig from "./moduleConfig";
import { Card, Row, Col } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";

import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import axios from "../../../config/axios";
import { createReducer, createInitialState } from "./reducers/createReducer";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../config/toastNotification";
import { ContainerLoading } from "../../UI/loading/ContainerLoading";
import ModuleCreateView from "../../UI/modules/views/ModuleCreateView";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import FormErrorMessage from "../../UI/errorMessages/FormErrorMessage";
import CMSFormDate from "../../UI/forms/CMSFormDate";
import CMSFormInput from "../../UI/forms/CMSFormInput";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import CMSRichTextEditor from "../../UI/forms/CMSRichTextEditor";
import CMSFormSelect from "../../UI/forms/CMSFormSelect";
import CMSFormRichText from "../../UI/forms/CMSFormRichText";
import CMSFormMultiSelect from "../../UI/forms/CMSFormMultiSelect";


let breadcrumbs = {
  listing: {
    label: moduleConfig.title,
    url: `/${moduleConfig.url}`,
  },
  create: {
    label: "Create",
  },
};

const PollCreate = () => {
  const [createState, createDispatch] = useReducer(
    createReducer,
    {
      ...createInitialState,
      activities: []
    }
  );
  const [activities, setActivities] = useState([])

  const { setBreadcrumb } = useContext(BreadcrumbContext);
  let navigate = useNavigate();
  const onSubmit = async (data) => {
    createDispatch({
      type: "FORM_SUBMISSION_REQUEST",
    });


    try {
      const res = await axios.post(`${moduleConfig.url}`, data); //
      //console.log(res);
      createDispatch({
        type: "FORM_SUBMISSION_SUCCESS",
        payload: res.data,
      });

      navigate(`/${moduleConfig.url}`);
      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `${moduleConfig.singleItemTitle} created successfully.`,
        type: "success",
      });
    } catch (error) {
      //console.log(error.response);
      const status = error.response ? error.response.status : 500;
      const errorMessage =
        status === 400 ? error.response.data.message : error.message;

      createDispatch({
        type: "FORM_SUBMISSION_FAILURE",
        payload: errorMessage,
      });
      setTimeout(() => {
        createDispatch({
          type: "FORM_INITIAL_STATE",
        });
      }, 5000);
    }
  };

  const loadActivities = async () => {
    try {
      const res = await axios.get(`${moduleConfig.url}/get-activities-list`); //
      //console.log("activities => ", res.data.activities)
      setActivities(res.data.activities)
      createDispatch({
        type: "FETCH_SUCCESS",
        payload: [],
      });
    } catch (error) {
      console.log("error in get activities")
    }
  };

  // const loadData = async () => {
  //     try {
  //         const res = await axios.get(`members/create-data`)//
  //         createDispatch({
  //             type: "FETCH_SUCCESS",
  //             payload: res.data
  //         });
  //     } catch (error) {
  //         createDispatch({
  //             type: "FETCH_FAILURE",
  //             payload: "Date loading failed."
  //         });
  //     }
  // }

  // const loadData = async () => {
  //   createDispatch({
  //     type: "FETCH_REQUEST",
  //   });

  //   try {
  //     const res = await axios.get(`${moduleConfig.url}/get-circles-members`); //
  //     createDispatch({
  //       type: "FETCH_SUCCESS",
  //       payload: res.data,
  //     });
  //   } catch (error) {
  //     createDispatch({
  //       type: "FETCH_FAILURE",
  //       payload: error,
  //     });
  //   }
  // };
  useEffect(() => {

    setBreadcrumb([breadcrumbs.listing, breadcrumbs.create]);
    loadActivities();
  }, []);
  return (
    <DashboardLayout>
      {createState.status === "fetchFailed" ? (
        <BlockErrorMessage error={createState.error} />
      ) : (
        <>
          {createState.status !== "fetching" && (
            <>
              <ModuleHeader
                moduleTitle={`Create ${moduleConfig.singleItemTitle}`}
                moduleUrl={moduleConfig.url}
              ></ModuleHeader>

              <section className="content">
                <Card>
                  <Card.Body>
                    {createState.isLoading && (
                      <div class="overlay position-absolute containerLoading">
                        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
                      </div>
                    )}
                    <Formik
                      initialValues={{
                        title: "",
                        description: "",
                        sortOrder: 99,
                        target: "All-Members",
                        // targetedCircles: ["123"],
                        status: "notStarted",
                        activityId: "",
                        resultType: "After Submission",

                      }}
                      validationSchema={yup.object({
                        title: yup.string().required("Required").max(100),
                        description: yup.string(),
                        sortOrder: yup.number(),
                        target: yup.string().required("Required"),
                        status: yup.string().required("Required"),
                        activityId: yup.string(),
                      })}
                      enableReinitialize={true}
                      validateOnChange={true}
                      validateOnBlur={true}
                      onSubmit={async (values) => {
                        //console.log(values)
                        onSubmit(values);
                      }}
                    >
                      {(form) => (
                        <Form onSubmit={form.handleSubmit}>
                          {createState.error && (
                            <FormErrorMessage error={createState.error} />
                          )}

                          <CMSFormInput
                            name="title"
                            label="Title"
                            form={form}
                            required={true}
                          />

                          <CMSFormSelect
                            name="target"
                            label="Target"
                            required={true}
                            form={form}
                            options={[
                              {
                                value: "All-Members",
                                label: "All Members"
                              },
                              {
                                value: "Selected-Members",
                                label: "Selected Members",
                              },
                              {
                                value: "Selected-Circles",
                                label: "Selected Circles",
                              },
                              {
                                value: "Attach-to-Activity",
                                label: "Attach to Activity",
                              },
                            ]}
                          />
                          {(form.values["target"] === "Attach-to-Activity") &&
                            <CMSFormSelect
                              name="activityId"
                              label="Attach to Activity"
                              required={false}
                              form={form}
                              options={activities}
                            />
                          }

                          <CMSFormInput
                            name="sortOrder"
                            label="Sort Order"
                            required={false}
                            form={form}
                          />



                          <CMSFormRichText
                            name="description"
                            label="Description"
                            form={form}
                          />

                          <CMSFormSelect
                            name="resultType"
                            label="Show Results On"
                            required={true}
                            form={form}
                            options={[
                              { value: "After Submission", label: "Show After Submission" },
                              { value: "After Announced", label: "Show After Announced" },
                              // { value: "On Authorized Screen", label: "Show On Authorized Screen" },
                            ]}
                          />

                          <CMSFormSelect
                            name="status"
                            label="Status"
                            required={true}
                            form={form}
                            options={[
                              { value: "disabled", label: "Disabled" },
                              { value: "notStarted", label: "Not Started" },
                              { value: "begun", label: "Begun" },
                              { value: "finished", label: "Finished" },
                              { value: "announced", label: "Results Announced" },
                              { value: "archived", label: "Archived" },
                            ]}
                          />

                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                        </Form>
                      )}
                    </Formik>
                  </Card.Body>
                </Card>
              </section>
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default PollCreate;
